export default defineNuxtPlugin((nuxtApp) => {
  // Errors During the Vue Rendering Lifecycle
  nuxtApp.hook('vue:error', (error, _, info) => {
    // eslint-disable-next-line no-console
    console.error(`[VUE_ERROR] [ERROR]: ${error} [INFO]: ${info}`);
  });
  // Server Startup Errors
  nuxtApp.hook('app:error', (error) => {
    // eslint-disable-next-line no-console
    console.error(`[APP_ERROR] [ERROR]: ${error}`);
  });
});
